import { scrollToAnchor } from "@/app/hooks/useScrollSmooth";
import Link from "next/link";
const NavBar = () => {
  const links = [ "Ester", "Sua jornada", "Diferenciais", "Nossa história", "Serviços"];
  return (
    <nav className="hidden md:flex items-center gap-8">
      {links.map((link, i) => (
        <Link
          key={i}
          scroll={false}
          href={`#${link
            .replace(" ", "-")
            .replace("ó", "o")
						.replace('ç', 'c')
            .toLocaleLowerCase()}`}
          className="text-gray-200 hover:text-[hsl(var(--accent))] transition-colors duration-300 font-medium text-lg scroll-smooth"
          onClick={() => {
           scrollToAnchor(
             link
               .replace(" ", "-")
               .replace("ó", "o")
               .replace("ç", "c")
               .toLocaleLowerCase()
           );
          }}
        >
          {link}
        </Link>
      ))}
    </nav>
  );
};

export default NavBar;
